// export const SuccessCard = ({ downloadUrl }: { downloadUrl: string }) =>{ 
//     const handleRedirect = () => {
//          const apiBase = process.env.REACT_APP_API_URL;
//          window.open(
//       `${apiBase}${downloadUrl}`,
//       "_blank",
//       "noopener,noreferrer"
//     );
//     }
//   return(<div style={{ maxWidth: 420, textAlign: "center" }}>
//     <h2>🎉 Klart!</h2>
//     <p>Din nedladdning är redo.</p>

    
//       <button  onClick={handleRedirect}>⬇️ Ladda ner nu</button>
    
//   </div>)
// ;}
export const SuccessCard = ({
  title,
  singleUse,
}: {
  title: string;
  singleUse?: boolean;
}) => {
  return (
    <div className="freebie-state-card freebie-state-card--success">
      <p className="freebie-state-card__kicker">Klart</p>
      <h2>Tack!</h2>

      <p className="freebie-state-card__body">
        Kolla din inkorg - {title} är på väg.
      </p>

      <p className="freebie-state-card__note">
        Om du inte fått din gåva inom tio minuter, kolla din skräppost så att den inte har hamnat där.
      </p>

      {singleUse && (
        <p className="freebie-state-card__note">
          Den här länken kan endast användas en gång.
        </p>
      )}
    </div>
  );
};
